import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { logOutOkta, refreshToken, GetFCOktaToken } from '../../data-store/actions/auth'
import { NavLink, useLocation, useNavigate } from 'react-router-dom'
import './header.scss'
import {
  Avatar,
  Popover,
  Box,
  Button,
  Divider,
  Grid,
  Snackbar,
  Alert
} from '@mui/material'
import ls from 'local-storage'
import jwtDecode from 'jwt-decode'
import AppsOutlinedIcon from '@mui/icons-material/AppsOutlined'
import { makeStyles } from '@mui/styles'
import BackButton from '../BackButton/BackButton'
import ScannedPackageCounter from '../ScannedPackageCounter/ScannedPackageCounter'
import IdleAlert from './IdleAlert'

const useStyles = makeStyles((theme) => ({
  root: {
    borderBottom: `1px solid ${theme.palette.primary.main}`,
    padding: '0px 10px',
    background: 'white'
  },
  counter: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  }
}))

const Header = () => {
  const account = useSelector((state) => state.auth)
  const packageCounts = useSelector((state) => state.finalScan.packageCounts)
  const [expiryEndTime, setExpiryEndTime] = useState(null)
  const [newExpiryTime, setNewExpiryTime] = useState(null)
  const [oktaExpiryEndTime, setOktaExpiryEndTime] = useState(null)
  let timer = null
  const [open, setOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const classes = useStyles()
  const location = useLocation()

  const initials = account.currentUser.initials
    ? account.currentUser.initials
    : 'NA'

  const currentExpTime = account.currentUser.exp
    ? account.currentUser.exp
    : null

  useEffect(() => {
    if (newExpiryTime !== currentExpTime) {
      setNewExpiryTime(currentExpTime)
    }
  })

  useEffect(() => {
    if (ls('token')) {
      const tokenDecoded = jwtDecode(ls('token'))
      let expiry = tokenDecoded.exp
      expiry = new Date(expiry * 1000)
      setExpiryEndTime(expiry)
    }
  }, [newExpiryTime])

  useEffect(() => {
    if (expiryEndTime) {
      const now = new Date()
      // expTime gives the total time the user has
      const expTime = expiryEndTime.getTime() - now.getTime()
      const timer = setTimeout(() => {
        dispatch(refreshToken())
      }, expTime)
      return () => clearTimeout(timer)
    }
  }, [expiryEndTime])

  useEffect(() => {
    if (oktaExpiryEndTime == null) {
      setOktaExpiryEndTime(new Date().getTime())
      dispatch(GetFCOktaToken())
    }
  }, [oktaExpiryEndTime])

  const formatTime = (value) => {
    return (value < 10 ? '0' + value : value.toString())
  }

  if (ls('token')) {
    timer = IdleAlert(1000)
  }

  const calculateTimeLeft = (expTime) => {
    let timeLeft = {}
    if (expTime > 0) {
      const min = Math.floor((expTime % 3600) / 60)
      const sec = Math.floor(expTime % 60)

      timeLeft = {
        mins: formatTime(min),
        secs: formatTime(sec)
      }
    }
    return timeLeft
  }

  if (timer === 0) {
    dispatch(logOutOkta())
  }

  useEffect(() => {
    if (ls('token')) {
      if (timer < 900) { // 15 min
        setOpen(true)
      } else {
        setOpen(false)
      }
    }
  }, [timer])

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleLogout = () => {
    setAnchorEl(null)
    dispatch(logOutOkta())
  }

  function capitalizeFirstLetter (string) {
    return string?.charAt(0).toUpperCase() + string?.slice(1)
  }

  const handleCloseIdle = () => {
    setOpen(false)
  }

  const handleRoles = () => {
    const elements = []
    for (let index = 0; index < account?.currentUser?.roles?.length; index++) {
      const permission = account?.currentUser?.roles[index].split('.')
      if (permission[0] === 'fulfillmentapp') {
        const element = capitalizeFirstLetter(permission[1])
        elements.push(<div key={index}>{element}</div>)
      }
    }
    return elements
  }

  return (
    <>
      <Snackbar open={open} onClose={handleCloseIdle}>
        <Alert severity='info'>In {calculateTimeLeft(timer).mins}:{calculateTimeLeft(timer).secs} minutes you will be automatically logged out due to inactivity</Alert>
      </Snackbar>
      <div className='header-wrapper'>
        <div className='header'>
          <div className='icon-logo-align'>
            <Button className='logo' variant='contained' onClick={() => navigate('/dashboard')}>
              <AppsOutlinedIcon />
            </Button>
            <Divider orientation='vertical' flexItem />
            <NavLink to='/dashboard' className='project-logo'>
              Fulfillment Application
            </NavLink>
          </div>
        </div>
        <div className='header-user'>
          <Avatar className='avatar' onClick={handleClick}>
            {initials}
          </Avatar>
          <Popover
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <>
              <Box p='10px'>
                <div>{account?.currentUser?.name}</div>
                <div>{account?.currentUser?.email}</div>
                <p style={{ padding: '5px 0px', margin: '0px' }}>Roles:</p>
                <div>{handleRoles()}</div>
              </Box>
              <Box p='10px'>
                <Button className='full-width' onClick={handleLogout}>
                  Logout
                </Button>
              </Box>
            </>
          </Popover>
        </div>
      </div>
      {
        location.pathname.match('/dashboard')
          ? null
          : (
            <Grid container className={classes.root}>
              <Grid item xs={6}>
                <BackButton />
              </Grid>
              <Grid item xs={6} className={classes.counter}>
                {
                  location.pathname.match('/finalscan')
                    // commented code to test the final scan performance
                    // ? <ScannedPackageCounter counterLabel='PACKAGES SCANNED' packageTypeCount={packageCounts.FinalScanCounts} />
                    ? null
                    : ((location.pathname.match('/stuff')
                      ? <ScannedPackageCounter counterLabel='PACKAGES STUFFED' packageTypeCount={packageCounts.StuffCounts} />
                      : null))
                }
              </Grid>
            </Grid>
          )
      }
    </>
  )
}

export default Header
